import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'
import { GET_ROLES } from 'graphql/queries'
import PropTypes from 'prop-types'

import { graphqlClient } from 'utils'
import { ROUTES } from 'utils/constants'

import RolesContext from './RolesContext'

const LoadRoles = ({ children }) => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  const getRoles = async () => {
    try {
      const { data } = await graphqlClient().query({
        query: GET_ROLES,
      })

      setData(data)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getRoles()
  }, [])

  if (error) {
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  if (loading) {
    return <LoadingContainer text='Carregando o usuário...' fullscreen />
  }

  if (!data.listRoles) {
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  return <RolesContext.Provider value={data.listRoles}>{children}</RolesContext.Provider>
}

LoadRoles.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LoadRoles
